import { MyClubCardsPage } from '#src/pages/my-cards/MyClubCardsPage/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const MyClubSlugCardsPage = () => {
  return <MyClubCardsPage<PageParams> />;
};
export default MyClubSlugCardsPage;
